module.exports = __webpack_public_path__ + "static/media/whistle_button.1a12026e.svg";